import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import type { Totals } from "../utils/acvRcv";

interface CoverageRadialProps {
  totals: Totals;
  reducedMotion?: boolean;
}

export default function CoverageRadial({ totals, reducedMotion }: CoverageRadialProps) {
  const data = [
    { name: "ACV (covered)", value: Math.max(totals.acv, 0.0001), color: "hsl(160 65% 42%)" },
    { name: "Gap (out of pocket)", value: Math.max(totals.gap, 0.0001), color: "hsl(348 75% 58%)" },
  ];
  const pct = Math.round(totals.coverage * 100);

  return (
    <div
      className="relative h-[260px] w-full"
      role="img"
      aria-label={`Insurance covers ${pct}% of replacement cost on an ACV policy`}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            innerRadius={70}
            outerRadius={100}
            paddingAngle={2}
            dataKey="value"
            stroke="none"
            isAnimationActive={!reducedMotion}
            animationDuration={700}
          >
            {data.map((d) => <Cell key={d.name} fill={d.color} />)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <div className="text-4xl font-editorial tabular-nums">{pct}%</div>
        <div className="text-[11px] uppercase tracking-wide text-muted-foreground mt-1">
          ACV coverage
        </div>
      </div>
    </div>
  );
}
